import {faWarning} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import UserBase from 'typescript/models/UserBase';
import * as Yup from 'yup';

const deleteInitValues = {
  confirmDelete: '',
};

const confirmDeleteSchema = Yup.object().shape({
  confirmDelete: Yup.string()
    .required('required field')
    .test('confirm delete test', 'Incorrect value, type DELETE to proceed', (val) => {
      return val === 'DELETE';
    }),
});

export default function ConfirmDeleteAccountForm({
  handleConfirmDelete,
  user,
}: {
  handleConfirmDelete: (values: {confirmDelete: string}) => Promise<void>;
  user: UserBase | null;
}) {
  return (
    <div className="delete-account__container">
      <div className="delete-account__welcome">
        <h1 className="delete-account__welcome-title">Are you sure you want to delete account?</h1>
        <h2 className="delete-account__welcome-subtitle">
          Deleting your account cannot be undone. Any personally identifiable information will be deleted and any
          in-progress data will be lost.
          <br />
          <br /> To confirm you want to permanently delete your account, please type the world &quot;DELETE&quot; in the
          box.
        </h2>
      </div>
      <Formik onSubmit={handleConfirmDelete} initialValues={deleteInitValues} validationSchema={confirmDeleteSchema}>
        <Form className="delete-account__form">
          <p>
            Logged in as: <strong>{`${user?.nickname} (${user?.email})`}</strong>
          </p>
          <div className="delete-account__form-control">
            <label className="delete-account__form-label">
              <FontAwesomeIcon icon={faWarning} />
              <Field name="confirmDelete" placeholder="DELETE..." className="delete-account__form-input" />
            </label>

            <ErrorMessage className="delete-account__form-error" name="confirmDelete" component="span" />
          </div>
          <div className="delete-account__cloud-down">
            <div className="delete-account__actions">
              <Button className="delete-account__signin-btn" variant="tertiary" type="submit">
                Delete my account permanently
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
      <div className="delete-account__footer" />
    </div>
  );
}
